import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef, ThemePalette} from "@angular/material";

export interface AlertDialogData {
  title?: string;
  titleData?: { [key: string]: any },
  body?: string;
  bodyData?: { [key: string]: any },
  okButton?: string;
  color?: ThemePalette;
}

@Component({
  selector: 'evicare-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss']
})
export class AlertDialogComponent {
  title: string;
  titleData: { [p: string]: any };
  body: string;
  bodyData: { [p: string]: any };
  okButton: string;
  color: ThemePalette;

  constructor(private readonly dialog: MatDialogRef<AlertDialogComponent>,
              @Inject(MAT_DIALOG_DATA) data: AlertDialogData) {
    this.title = data.title;
    this.titleData = data.titleData;
    this.body = data.body;
    this.bodyData = data.bodyData;
    this.okButton = data.okButton;
    this.color = data.color || 'primary';
  }

  submit(event: Event): void {
    event.preventDefault();

    this.dialog.close(true);
  }
}
